/* global localStorage:false, swal:false */
(function () {
  "use strict";

  angular
    .module("admin.communities.service", [])
    .factory("CommunitiesService", CommunitiesService);

  /** @ngInject */
  function CommunitiesService($http, $q, API) {
    function search(roles, start, limit) {
      var defer = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/users?role=" +
            roles +
            "&start=" +
            start +
            "&limit=" +
            limit
        )
        .success(defer.resolve);

      return defer.promise;
    }

    return {
      search: search,
    };
  }
})();
